import type { TFunction } from 'i18next';
import { useMemo } from 'react';
import type { FlagGlossaryFiltersCardProps } from '../filters/flagGlossaryFiltersCard.types';
import { buildFlagGlossaryBaseState } from './buildFlagGlossaryBaseState';
import type {
  FlagGlossaryEntry,
  FlagGlossaryFilterValues,
  FlagGlossaryKpiCounts,
  FlagGlossaryRowView,
} from './flagGlossary.types';
import { filterFlagGlossaryRows } from './flagGlossaryFiltering';
import { useFlagGlossaryFilters } from './useFlagGlossaryFilters';

type UseFlagGlossaryViewInput = {
  entries: FlagGlossaryEntry[];
  t: TFunction;
};

export const useFlagGlossaryView = ({
  entries,
  t,
}: UseFlagGlossaryViewInput): {
  filters: FlagGlossaryFilterValues;
  filtersProps: Omit<FlagGlossaryFiltersCardProps, 'theme'>;
  filteredRows: FlagGlossaryRowView[];
  kpiCounts: FlagGlossaryKpiCounts;
} => {
  const baseState = useMemo(
    () => buildFlagGlossaryBaseState(entries, t),
    [entries, t],
  );

  const { filters, filtersProps } = useFlagGlossaryFilters({
    categoryOptions: baseState.categoryOptions,
  });

  const filteredRows = useMemo(
    () => filterFlagGlossaryRows(baseState.allRows, filters),
    [baseState.allRows, filters],
  );

  return {
    filters,
    filtersProps,
    filteredRows,
    kpiCounts: baseState.kpiCounts,
  };
};
